export const escapeUrlWithProtocol = (url?: string): string | undefined =>
  !url ? undefined : url.indexOf('http') === 0 ? url : `http://${url}`;
